<template>
    <main class="skiplink-target main" id="content" tabindex="-1">
        <div class="container" v-bind:class="[containerClass, {'spinner': !labels.introscherm}]">
        <header class="row">
            <div class="col-xl-8 col-xl-offset-2 col-lg-10 col-lg-offset-1">
                <div class="content content--header">
                    <a v-if="labels.introscherm" class="backlink" v-bind:href="labels.algemeen.linkUitapplicatie" >
                        <i class="backlink__icon icon-arr-backward icon--size-l"></i>
                        {{labels.algemeen.linkUitapplicatieTekst}}
                    </a>
                    <section class="content-header">
                        <h1 v-if="labels.introscherm">{{labels.introscherm.kop}}</h1>
                    </section>
                </div>
            </div>
        </header>
        <article>
            <div class="row" v-if="labels.introscherm">
                <div class="col-xl-8 col-xl-offset-2 col-lg-10 col-lg-offset-1">
                    <div class="content-background">
                        <div class="content">
                            <h2>{{labels.introscherm.subkop}}</h2>
                            <p v-html="labels.introscherm.introductieTekst"></p>
                            <p>
                                <router-link v-bind:class="[btnClass]" :to="{name: 'reden-contact'}">{{labels.algemeen.button}}
                                </router-link>
                            </p>
                        </div>
                    </div>
                </div>
            </div>

        </article>
        </div>
    </main>
</template>

<script>
    import {mapGetters} from 'vuex';

    export default {
        name: "introScherm",
        computed: {
            ...mapGetters(['labels'])
        },
        created() {
            this.$trackPageView('Intro scherm');              
        },
        data() {
            return {
                containerClass: 'container',
                btnClass: 'btn btn--primary'
            }
        }
    }
</script>

<style scoped>


</style>
